
      function getAbsoluteUrl(relativeUrl) {
        const publicPath = __webpack_public_path__;

        let url = '';

        if (!publicPath || publicPath.indexOf('://') < 0) {
          url += window.location.protocol + '//' + window.location.host;
        }

        if (publicPath) {
          url += publicPath;
        } else {
          url += '/';
        }

        return url + relativeUrl;
      }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createDbWorker } from "sql.js-httpvfs";

// import HelloWorld from "@/components/HelloWorld.vue";

const publicPath =
  process.env.NODE_ENV === "production" ? "/vue-sql.js-httpvfs/" : "/";

const workerUrl = new URL(
  `${publicPath}sql.js-httpvfs/sqlite.worker.js`,
  ({ url: getAbsoluteUrl('src/App.vue?vue&type=script&lang=js&') }).url
);
const wasmUrl = new URL(
  `${publicPath}sql.js-httpvfs/sql-wasm.wasm`,
  ({ url: getAbsoluteUrl('src/App.vue?vue&type=script&lang=js&') }).url
);

export default {
  name: "App",
  components: {
    // HelloWorld,
  },
  data() {
    return {
      result: undefined,
    };
  },
  async mounted() {
    this.worker = await createDbWorker(
      [
        {
          from: "inline",
          config: {
            serverMode: "full",
            url: `${publicPath}db/example.sqlite3`,
            requestChunkSize: 4096,
          },
        },
      ],
      workerUrl.toString(),
      wasmUrl.toString()
    );
  },
  methods: {
    async runSql(sql) {
      this.result = await this.worker.db.query(sql);
    },
  },
};
